import "@/App.css";
import HomePage from "@/pages/HomePage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <HomePage />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
